import { memo } from 'react';

import { useApolloClient } from '@apollo/client/react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import ScraperListingCard from '@modules/_shared/components/scraper-listing-card/ScraperListingCard';
import { initialListingComparableDetails } from '@modules/reports/cma-reports/step-listing-compare/ListingComparableDetails';
import type { CmaListingWithDistance } from '@modules/reports/cma-reports/step-listing-compare/types';

type CmaScraperCardProps = {
  cmaListingDistance: CmaListingWithDistance;
  variant: 'horizontal' | 'vertical';
  showAgencyName?: boolean;
  showContactName?: boolean;
  showDaysOnMarket?: boolean;
  showOfflineSince?: boolean;
  positionDateBadge?: 'image' | 'inline';
};

const CmaScraperCard = ({
  cmaListingDistance,
  variant,
  showAgencyName = false,
  showContactName = false,
  showDaysOnMarket = true,
  showOfflineSince = true,
  positionDateBadge = 'image',
}: CmaScraperCardProps) => {
  const client = useApolloClient();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { listing, distance_in_meters } = cmaListingDistance;

  const handleClickCard = () => {
    const compositeListingId = `${listing.id}/${listing.state_id}`;
    const encodedListingId = btoa(compositeListingId);

    navigate({
      pathname: `${encodedListingId}`,
      search: searchParams.toString(),
    });
  };

  const handleHover = () => {
    client.query(
      initialListingComparableDetails(
        listing.id,
        listing.country_code ?? 'CH',
        listing.state_id,
      ),
    );
  };

  return (
    <ScraperListingCard
      listing={listing}
      variant={variant}
      onClick={handleClickCard}
      onHover={handleHover}
      showAgencyName={showAgencyName}
      showContactName={showContactName}
      showDistance
      distanceInMeters={distance_in_meters}
      showPricePerSqm
      showDaysOnMarket={showDaysOnMarket}
      showOfflineSince={showOfflineSince}
      dateBadgePosition={positionDateBadge}
    />
  );
};

export default memo(CmaScraperCard);
